<form [formGroup]="form">
	<div mat-dialog-title class="dialog-title">
		<div class="title">{{ I18N_CC.CORRECT_DIALOG_TITLE | i18n | async }}</div>
		<button mat-icon-button mat-dialog-close class="close-btn">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content>
		<!-- Salutation -->
		<mat-form-field appearance="outline" class="field-full">
			<mat-label>{{ I18N_CC.CORRECT_SALUTATION | i18n | async }}</mat-label>
			<mat-select formControlName="salutation">
				@for (option of salutationOptions; track option) {
					<mat-option [value]="option">{{ option || '—' }}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<!-- First name -->
		<mat-form-field appearance="outline" class="field-full">
			<mat-label>{{ I18N_CC.CORRECT_FIRSTNAME | i18n | async }}</mat-label>
			<input matInput formControlName="firstName" />
		</mat-form-field>

		<!-- Last name -->
		<mat-form-field appearance="outline" class="field-full">
			<mat-label>{{ I18N_CC.CORRECT_LASTNAME | i18n | async }}</mat-label>
			<input matInput formControlName="lastName" />
		</mat-form-field>

		<!-- Company -->
		<mat-form-field appearance="outline" class="field-full">
			<mat-label>{{ I18N_CC.CORRECT_COMPANY | i18n | async }}</mat-label>
			<input matInput formControlName="company" />
		</mat-form-field>

		<!-- Phone type + number -->
		<div class="phone-row">
			<mat-form-field appearance="outline" class="field-phone-type">
				<mat-label>{{ I18N_CC.CORRECT_PHONE_TYPE | i18n | async }}</mat-label>
				<mat-select formControlName="telephoneType">
					@for (opt of phoneTypeOptions; track opt.value) {
						<mat-option [value]="opt.value">{{ opt.label }}</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="field-phone-number">
				<mat-label>{{ I18N_CC.CORRECT_PHONE_NUMBER | i18n | async }}</mat-label>
				<input matInput formControlName="telephoneNumber" />
			</mat-form-field>
		</div>

		<!-- Addressbook sync: CASE 1 — not linked (checkbox) -->
		@if (!isLinked) {
			<div class="sync-section">
				<mat-checkbox
					[checked]="syncValue() === SyncEnum.CREATE"
					(change)="form.get('syncToAddressBook')?.setValue($event.checked ? SyncEnum.CREATE : SyncEnum.NO)"
				>
					{{ I18N_CC.CORRECT_ADD_TO_ADDRESSBOOK | i18n | async }}
				</mat-checkbox>
			</div>
		}

		<!-- Addressbook sync: CASE 2 — linked (radio group) -->
		@if (isLinked) {
			<div class="sync-section">
				<mat-radio-group formControlName="syncToAddressBook" class="sync-radios">
					<mat-radio-button [value]="SyncEnum.UPDATE">
						{{ I18N_CC.CORRECT_SYNC_UPDATE | i18n | async }}
					</mat-radio-button>
					<mat-radio-button [value]="SyncEnum.NO">
						{{ I18N_CC.CORRECT_SYNC_UNLINK | i18n | async }}
					</mat-radio-button>
					<mat-radio-button [value]="SyncEnum.CREATE">
						{{ I18N_CC.CORRECT_SYNC_CREATE_NEW | i18n | async }}
					</mat-radio-button>
				</mat-radio-group>
			</div>
		}

		<!-- CREATE mode validation hint -->
		@if (createValidationError()) {
			<div class="validation-hint">
				{{ I18N_CC.CORRECT_VALIDATION_NAME_OR_COMPANY | i18n | async }}
			</div>
		}
	</mat-dialog-content>

	<mat-dialog-actions>
		<button matButton="outlined" class="cft-button" mat-dialog-close>
			{{ I18N_CC.CORRECT_CANCEL | i18n | async }}
		</button>
		<button matButton="filled" class="cft-button" (click)="onSave()">
			{{ I18N_CC.CORRECT_SAVE | i18n | async }}
		</button>
	</mat-dialog-actions>
</form>
